/**
 * Notifications API - alerts for messages, likes, follows
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const notificationsApi = {
  // Get current user's notifications
  getMy: async (limit = 30) => {
    const res = await axios.get(`${API_URL}/api/notifications/my?limit=${limit}`, {
      headers: getAuthHeaders()
    });
    return res.data; // { notifications, unreadCount, total }
  },

  // Mark all notifications as read
  markAllRead: async () => {
    const res = await axios.post(
      `${API_URL}/api/notifications/mark-read?mark_all=true`,
      {},
      { headers: getAuthHeaders() }
    );
    return res.data;
  },

  // Mark specific notifications as read
  markRead: async (ids = []) => {
    const params = ids.map(id => `notification_ids=${encodeURIComponent(id)}`).join('&');
    const res = await axios.post(
      `${API_URL}/api/notifications/mark-read?${params}`,
      {},
      { headers: getAuthHeaders() }
    );
    return res.data;
  },

  // Delete a notification
  remove: async (id) => {
    const res = await axios.delete(`${API_URL}/api/notifications/${id}`, {
      headers: getAuthHeaders()
    });
    return res.data;
  }
};

export default notificationsApi;
